module.exports = __webpack_public_path__ + "static/img/chenlong.885a914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/chenlong.png
// module id = ZCD6
// module chunks = 0